<div class="container">
	<mat-icon class="icon" svgIcon="ic-access-denied" />

	<div class="content">
		<h2 class="title">{{ 'accessDenied.title' | translate }}</h2>
		<p class="description">{{ 'accessDenied.description' | translate }}</p>
	</div>
</div>
